module.exports = __webpack_public_path__ + "static/media/phone.daf7f194.svg";